import type { AxiosError, AxiosResponse } from 'axios'
import { EApiErrorCodes } from '@/types/enums'

const responseInterceptor = (response: AxiosResponse): Promise<AxiosResponse> => {
  return response.data
}

const errorInterceptor = (error: AxiosError): Promise<AxiosError> => {
  if ((error.response?.data as { code: EApiErrorCodes }).code === EApiErrorCodes.STORE_DISABLED) {
    const { openModal } = useModals()

    openModal('storeIsBlockedModal')
  }

  return Promise.reject(error)
}

export {
  responseInterceptor,
  errorInterceptor
}
